import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import * as Forms from '../../../../components/form-elements/_index';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { DocumentSingleReport } from '../../../../models/production/document-single-report';
import { SelectListItem } from '../../../../models/utilities/selectlist-item';
import { ProductionLine } from '../../../../production/models/enums/production-line';
import { SingleReportOptionsMetadata } from '../../../../modules/reports/models/single-report-options';
import { ProductionSvc } from '../../../../production/service';
import { StatusCode } from '../../../../utils/api';

export const ProductionSinglePaperwork = () => {

    const dispatch = useDispatch();
    const [service] = React.useState(new ProductionSvc());
    const [isOpen, setIsOpen] = React.useState(false);
    const [selectedRun, setRunId] = React.useState("");   
    const [selectedProductionLine, setSelectedProductionLine] = React.useState<ProductionLine>(-1);
    const [selectedReport, setSelectedReport] = React.useState<number>(-1);
    const [reportOptions, setReportOptions] = React.useState<Array<SelectListItem<string>>>([]);
    const [runOptions, setRunOptions] = React.useState<Array<SelectListItem<string>>>([]);

    const [productionLineOptions] = React.useState(() => {
        const lines: Array<SelectListItem<ProductionLine>> = [];

        for (let line of SingleReportOptionsMetadata.productionLines) {

            lines.push(new SelectListItem({
                id: line.productionLine, name: line.name
            }));
        }
        return lines;
    });

    async function getRuns() {
        const res = await service.getProductionSchedule();
        if (res.status === StatusCode.Success) {
            //const cloned = cloneDeep(res.data);

            const runOpts : Array<SelectListItem<string>> = [];

            for (let run of res.data) {
                runOpts.push(new SelectListItem({
                    id: run.id, name: `Run ${run.id} - ${run.name} (Shipment ${run.shipmentId})`
                }));
            }

            setRunOptions(runOpts);
        }
    }

    const onProductionLineChange = (e: any) => {
        setSelectedProductionLine(e.target.value);

        var lineOptions = SingleReportOptionsMetadata.productionLines.filter((line) => line.productionLine == e.target.value);
        if (lineOptions.length <= 0) {
            setReportOptions([]);
        }
        else {

            const reportOptions: Array<SelectListItem<string>> = [];

            var lineOption = lineOptions[0];

            for (let i = 0; i < lineOption.reports.length; i++) {
                const report = lineOption.reports[i];
                reportOptions.push(new SelectListItem({
                    id: i, name: report.displayName
                }))
            }
            setReportOptions(reportOptions);
        }
    }

    const onReportChange = (e: any) => {
        setSelectedReport(e.target.value);
    }


    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
        getRuns();
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setRunId("");
        setSelectedReport(-1);
        setSelectedProductionLine(-1);
        setIsOpen(false);
    };

    /**
     * Format the dates and initiate the run credit report command
     */
    const runReport = () => {

        const parseResult = Number.parseInt(selectedRun, 10);
        if (!isNaN(parseResult)) {
            var lineOptions = SingleReportOptionsMetadata.productionLines.filter((line) => line.productionLine == selectedProductionLine);
            if (lineOptions.length <= 0) {
                return;
            }
            var lineOption = lineOptions[0];

            var reportOption = lineOption.reports[selectedReport];

            const req = new DocumentSingleReport(Number(parseResult), lineOption.productionLine, reportOption.name, reportOption.listType, reportOption.windowsListType, reportOption.division);
            dispatch(getDocumentHelper(req));

            onCloseClick();
        }
    };

    /**
     * Handler for changing the cutoff date.
     * @param newDate The new cutoff date as chosen 
     */
    const onSelectedRunChange = (e: any) => {
        setRunId(e.target.value);
    };

    return <React.Fragment>
        <div className="report-card-wrap blue">
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h3>Production Paperwork (Single)</h3>
                            <p>Export production paperwork for a specified run, production line, and report.</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <DialogTrigger
                                onClick={onOpenClick}
                                text="Run Report" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={isOpen}
            className="report-dialog"
            onClose={onCloseClick}
            maxWidth="md"
            aria-labelledby="form-dialog-title">

            <DialogHeader>
                <h1>Run Export</h1>
            </DialogHeader>

            <DialogContent>
                <div className="row">
                    <div className="col">
                        <p>Provide a run id to include in the paperwork bundle.</p>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col">
                        <Forms.SelectInput
                            id="run"
                            testID="single-report-run"
                            label="Run"
                            onChange={onSelectedRunChange}
                            options={runOptions}
                            value={selectedRun}
                            default={''}
                            disable={false} />
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col">
                        <Forms.SelectInput
                            id="productionLine"
                            testID="single-report-production-line"
                            label="Line"
                            onChange={onProductionLineChange}
                            options={productionLineOptions}
                            value={selectedProductionLine}
                            default={-1}
                            disable={false} />
                    </div>
                </div>
                {
                    selectedProductionLine > -1 ?
                        <div className="row justify-content-around">
                            <div className="col">
                                <Forms.SelectInput
                                    id="report"
                                    testID="single-report-report"
                                    label="Report"
                                    onChange={onReportChange}
                                    options={reportOptions}
                                    value={selectedReport}
                                    default={''}
                                    disable={false} />
                            </div>
                        </div>
                        : null
                }
            </DialogContent>
            <DialogActions>
                <FlatButton
                    id="accountmateNoBtn"
                    text="Cancel"
                    classes="negative"
                    onBtnClick={onCloseClick} />
                <FlatButton
                    id="accountmateYesBtn"
                    text="Go"
                    disable={!selectedRun || selectedProductionLine < 0 || selectedReport < 0}
                    classes="positive"
                    onBtnClick={runReport} />
            </DialogActions>
        </Dialog>
    </React.Fragment>;

};
